import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { getUserNotifications, markAllNotificationsAsRead } from '../services/api'
import { useToken } from '../utils/auth'

/**
 * 사용자 알림 목록을 조회하는 훅
 * React Query로 캐싱 및 자동 관리
 */
export const useNotifications = () => {
	const token = useToken()

	return useQuery({
		queryKey: ['notifications'],
		queryFn: () => getUserNotifications(token),
		enabled: !!token, // 토큰이 있을 때만 실행
		staleTime: 1000 * 60 * 2, // 2분간 캐시 유지
		retry: 1,
	})
}

/**
 * 모든 알림을 읽음 처리하는 mutation 훅
 */
export const useMarkAllAsRead = () => {
	const token = useToken()
	const queryClient = useQueryClient()

	return useMutation({
		mutationFn: () => markAllNotificationsAsRead(token),
		onSuccess: (response) => {
			console.log('읽음 처리 성공:', response)
			// 알림 목록 캐시 무효화 및 리페칭
			queryClient.invalidateQueries(['notifications'])
		},
		onError: (error) => {
			console.error('알림 읽음 처리 실패:', error)
		},
	})
}
